export const lc_name_cfg = {
  version: 1,
  updatedAt: null,
  updatedBy: null,
  enabled: true,
  rules: {
    useDiacriticsBoost: true,
    useSurnameEndings: true,
    minLithuanianScore: 2,
    diacriticsScore: 4,
    ltGivenNameScore: 2,
    ltSurnameScore: 2,
    ltSurnameEndingScore: 2,
    nonLtGivenNameScore: -2,
    nonLtSurnameScore: -2,
    foreignDiacriticsScore: -2,
    foreignEndingScore: -2,
    tokenCountBoostScore: 1,
  },
  dictionaries: {
    lt: {
      givenNames: {
        laimonas: true,
        matas: true,
        deimantė: true,
        gintarė: true,
        vilmandas: true,
        rima: true,
        rita: true,
        aida: true,
        povilas: true,
        arūnas: true,
        antanas: true,
        justinas: true,
        gabrielė: true,
        gražvilė: true,
        augustinas: true,
        darius: true,
        jurgita: true,
        viktorija: true,
        petras: true,
        jonas: true,
        tomas: true,
        raigardas: true,
        ieva: true,
        roberta: true,
        linas: true,
      },
      surnames: {
        bruzgytė: true,
        milašius: true,
        balužis: true,
        žinys: true,
        šaulinskas: true,
        "čer-nauskas": true,
        černauskas: true,
        lukoševičiūtė: true,
        vilutytė: true,
        aukštikalis: true,
        lumbytė: true,
        venclovaitė: true,
        stanišauskaitė: true,
        aukštikalnytė: true,
        vidziunas: true,
        šilinskas: true,
        beliūnas: true,
      },
      surnameEndings: {
        aitis: true,
        ytis: true,
        utis: true,
        evičius: true,
        avičius: true,
        auskas: true,
        inskas: true,
        skas: true,
        onis: true,
        ūnas: true,
        enas: true,
        ickas: true,
        aitė: true,
        ytė: true,
        utė: true,
        ienė: true,
        ūtė: true,
        iūtė: true,
        onytė: true,
        ūte: true,
        ius: true,
        is: true,
        as: true,
        ys: true,
        us: true,
      },
    },
    nonLt: {
      givenNames: {
        alex: true,
        miguel: true,
        michael: true,
        john: true,
        mohamed: true,
        mohammad: true,
        juan: true,
        carlos: true,
        ahmed: true,
        ali: true,
        maria: true,
        jose: true,
        pablo: true,
        sathish: true,
        silencio: true,
      },
      surnames: {
        meyer: true,
        fernandez: true,
        skalski: true,
      },
    },
  },
};
